import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';
import { captureError, logErrorAction, logInfoAction } from 'src/app/shared/util/error-capture.util';
import { CookiesService } from '../auth/cookies.service';

@Injectable({
  providedIn: 'root'
})
export class FileExchangeService {
  private readonly API = `${environment.chatbotServiceUrl}/document-pipeline/run`;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private cookiesService: CookiesService
  ) { }

  async uploadFile(file: File): Promise<any> {
    try {
      const headers = await this.authService.buildAPIAuthHeaderMultiPart();
      const formData = new FormData();

      const userData = {
        institutionId: this.cookiesService.getCookie('institutionId'),
        clinicName: this.cookiesService.getCookie('institutionName') || '',
        documentType: file.type || '',
        healthMemberId: this.cookiesService.getCookie('userId'),
      }
      const fileType = 'PTS';
      formData.append('file', file);
      formData.append('institutionId', userData.institutionId);
      formData.append('documentType', fileType);
      formData.append('healthMemberId', userData.healthMemberId);

      logInfoAction('Uploading file', {
        fileName: file.name,
        fileSize: file.size,
        file: file
      });
      const importedFile = await this.http.post(`${this.API}`, formData, { headers }).toPromise();
      return importedFile;
    } catch (error) {
      logErrorAction('Uploading file failed', error);
      captureError(error, {
        component: 'file-exchange.service',
        operation: 'uploadFile',
        extraData: { fileName: file.name }
      });
      throw error;
    }
  }
}
